module.exports = __webpack_public_path__ + "static/Banner-a6bf260cd1199a0955b7273ebc037db8.svg";